(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Auth0Identity"] = factory();
	else
		root["Auth0Identity"] = factory();
})((typeof ArcSDK !== 'undefined' ? ArcSDK : this), function() {
return 